import React from "react";
import NavigationBar from "./NavigationBar";
import { useState, useEffect } from "react";
import Login from "./Login";
import EMMS from "./EMMS";
import License from "./License";
import TitleWithDropdown from "./TitleWithDropdown";
import Location from "./Location";
import MyLocationForm from "./MyLocationForm";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import MyMeetingSpaceForm from "./MyMeetingSpaceForm";
import MeetingSpace from "./MeetingSpace";
import image from "../logos/meetingspace.png";
import { mergeAndJoinFields } from "../utils/mergeAndJoinFields";

import {
  setCurrentEmms,
  setLogoutCurrentEmms,
} from "../redux/slices/currentEmmsSlice";
import { setEmmsHeaders, setEmmsLogout } from "../redux/slices/emmsAuthSlice";
import { setLocation } from "../redux/slices/locationSlice";
import { setMeetingSpaces } from "../redux/slices/allMeetingSpacesSlice";
import GroupList from "./GroupList";
import { setGroups } from "../redux/slices/groupsSlice";

function MeetingSpaceDashboard() {
  const api = localStorage.getItem("api");
  const dispatch = useDispatch();
  const emms = useSelector((state) => state.emms);
  const [login, setLogin] = useState(false);
  let selectedEmms = null;
  const [responseData, setResponseData] = useState(null);
  const headers = useSelector((state) => state.header);
  const [errors, setErrors] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [locationOptions, setLocationOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(emms?.emms?.[0]?.id);
  const emmsheaders = useSelector((state) => state.emmsheader);

   const handleLocationData = async () => {
  const requestBody = {
    path: "location",
    query: {},
    emmsId: `${selectedOption}`,
    body: {},
    requestType: "GET",
    headers: emmsheaders?.emmsheaders?.headers,
  };

  try {
    const response = await axios.post(
      api + `/emms/piggyback`,
      requestBody,
      headers
    );

    dispatch(setLocation(response.data));
    setLocationOptions(response.data);

    return response.data;
  } catch (error) {
    setErrors(true);
    return [];
  }
}

  async function fetchData(value) {
    setIsLoading(true);
    let selectedEmms = emms?.emms?.find((element) => element.id === value);
    dispatch(setCurrentEmms(selectedEmms));

    if (selectedEmms !== null) {
      const apiId = selectedEmms?.apiId;
      const apiKey = selectedEmms?.apiKey;
      dispatch(setCurrentEmms(selectedEmms));
      const locations = await handleLocationData()

      const emmsheaders = {
        headers: {
          "Content-Type": "application/json",
          "x-api-id": apiId,
          "x-api-key": apiKey,
        },
      };

      dispatch(setEmmsHeaders(emmsheaders));
      const requestBody = {
        path: "meetingspace",
        query: {},
        emmsId: value,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };

      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          setResponseData(response.data);
          
        const input = {
          baseTable: response?.data || [],
          joins: [
            {
              joinTable: locations || [],
              correlation: ["locationId", "id"],
              fields: [
                {
                  name: "location_details",
                  fieldsToJoin: ["city", "building", "floor"]
                }
              ],
              separator: ", "
            },

          ]
        };

        const result = mergeAndJoinFields(input);

          dispatch(setMeetingSpaces(result));
          setErrors(false);
        })
        .catch((error) => {
          console.log("error ",error)
          setErrors(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }
  function fetchGroupData(value) {
    let selectedEmms = emms?.emms?.find((element) => element.id === value);
    dispatch(setCurrentEmms(selectedEmms));

    if (selectedEmms !== null) {
      const apiId = selectedEmms?.apiId;
      const apiKey = selectedEmms?.apiKey;
      dispatch(setCurrentEmms(selectedEmms));

      const emmsheaders = {
        headers: {
          "Content-Type": "application/json",
          "x-api-id": apiId,
          "x-api-key": apiKey,
        },
      };

      dispatch(setEmmsHeaders(emmsheaders));
      const requestBody = {
        path: "groups",
        query: {},
        emmsId: value,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };

      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          dispatch(setGroups(response?.data));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  useEffect(() => {
    fetchData(selectedOption);
    fetchGroupData(selectedOption);
  }, []);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    fetchData(event?.target?.value);
  };

  const options = emms?.emms?.map((emm) => ({
    label: emm.name,
    value: emm.id,
  }));

  return login == null ? (
    <Login />
  ) : (
    <>
      <div className="mainContainer emms-main-container">
        <header className="no-margin">
          <figure>
            <img className="img" src={image} alt="Logo" />
          </figure>
        </header>
        <div className="title-container">
          <div className="title">
            <TitleWithDropdown
              title="EMMS Service"
              options={options}
              selectedOption={selectedOption}
              onOptionChange={handleOptionChange}
            />
          </div>
          <div style={{ display: "flex", gap: "1rem" }}>
            <div>
              <GroupList selectedOption={selectedOption} />
            </div>
            <div>
              <MyMeetingSpaceForm selectedOption={selectedOption} locationOptions={locationOptions} />
            </div>
          </div>
        </div>
        <div className="emms-main-container-left-align" style={{ marginLeft: "10%" }}>
          <MeetingSpace selectedOption={selectedOption} errors={errors} isLoading={isLoading} />
        </div>
      </div>
    </>
  );
}

export default MeetingSpaceDashboard;
